import React from 'react';
import Routes from './routes';
import './global.css';
import { Provider } from 'react-redux';
import { store } from './store/store';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { BrowserRouter } from 'react-router-dom';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
        localStorage.clear();
        window.location.reload();
    }

    render() {
        if (this.state.hasError) {
            return <div style={{
                backgroundColor: 'white',
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column'
            }}>

                <h1>Houve um erro inesperado e você será redirecionado para a tela de login!</h1>

            </div>;
        }

        return this.props.children;
    }
}

export default function App() {
    return (
        <>
            <Provider store={store}>

                <BrowserRouter>
                    <main className="app">
                        <Routes className="Login" />
                    </main>
                </BrowserRouter>

            </Provider>
        </>
    );
}
